export const JEDI_HR_URL = process.env.REACT_APP_URL_JEDI_HR_URL;
export const ATTENDANCE_API_URL = process.env.REACT_APP_URL_ATTENDANCE_API;
export const LEAVE_API_URL = process.env.REACT_APP_URL_LEAVE_URL;
export const ONBOARDING_API_URL = process.env.REACT_APP_URL_ONBOARDING_API;
console.log(" process.env.ENV", process.env.REACT_APP_ENV);
console.log(" process.env.JEDI_HR_URL", process.env.REACT_APP_URL_JEDI_HR_URL);

export const ATTENDANCE_URL =
  process.env.REACT_APP_ENV === "UAT"
    ? "https://people-attendanceportal-uat.more.in/login"
    : "https://people-attendanceportal.more.in/login";
